import React from "react";
// The import below should be updated to match your Router component
import DynamicSitemap from "react-dynamic-sitemap";
import RoutSwitch from "../../components/RoutSwitch";

export default function Sitemap(props) {
    return (
        <DynamicSitemap routes={RoutSwitch} prettify={true} {...props}/>
    );
}